const route = 'https://chanceorthodontics.com/wp-json'

const api = () => {
  return route
}

export default api()



// WEBPACK FOOTER //
// ./src/shared/api/api.js